export default {
    apiGetOfflineAssessments(data) {
        return this.request(this.api().getOfflineAssessments, data)
            .exec()
            .log()
            .mapresults((response) => {
                let records = response?.data?.records || [];
                let page = parseInt(data.page) || 1;
                let limit = parseInt(data.limit) || 10;
                records = records.map((record, index) => {
                    return {
                        ...record,
                        _id: record._id,
                        parameter_id: ((page - 1) * limit) + index + 1,
                        school_name: record.school?.school_name || "N/A",
                        academic_year: record.academic_year_id?.display_value || "N/A",
                        no_of_parameter: record.parameters?.length < 10 ? `0${record.parameters.length}` : record.parameters?.length,
                        created_on: new Date(record.createdAt).toLocaleDateString('en-GB').replace(/\//g, '-'),
                        parameters: record.parameters || []
                    };
                });
                return {
                    data: records,
                    total: response?.data?.totalCount || 0,
                };
            })
            .get();
    },
    apiCreateOfflineAssessment(data) {
        return this.request(this.api().createOfflineAssessment, data)
            .exec()
            .log()
            .get();
    },

    apiGetOfflineAssessmentById(params) {
        return this.request(this.api().getOfflineAssessmentById, params)
            .urltransform(params)
            .exec()
            .log()
            .get();
    },

    apiDeleteOfflineAssessmentById(params) {
        return this.request(this.api().deleteOfflineAssessmentById, params)
            .urltransform(params)
            .exec()
            .log()
            .get();
    },

    apiUpdateOfflineAssessmentById(data, urldata = {}) {
        return this.request(this.api().updateOfflineAssessmentById, data)
            .urltransform(urldata)
            .exec()
            .log()
            .get();
    },

    apiGetAcademicYears(data) {
        return this.request(this.api().getAcademicYears, data)
            .exec()
            .log()
            .mapresults((response) => {
                let records = response?.data?.items || response?.data?.records || response?.data || response?.items || response?.records || response || [];
                return {
                    data: Array.isArray(records) ? records : (records?.items || records?.records || []),
                    total: response?.count || response?.totalCount || 0,
                    raw: response
                };
            })
            .get();
    },

    apiGetOfflineAssessmentParameters(data) {
        return this.request(this.api().getOfflineAssessmentParameters, data)
            .exec()
            .log()
            .mapresults((response) => {
                let records = response?.data?.items || response?.data?.records || response?.data || response?.items || response?.records || response || [];
                return {
                    data: Array.isArray(records) ? records : (records?.items || records?.records || []),
                    total: response?.count || response?.totalCount || 0,
                    raw: response
                };
            })
            .get();
    },

    apiGetMasterCategory(data) {
        return this.request(this.api().getMasterCategory, data)
            .exec()
            .log()
            .mapresults((response) => {
                let records = response?.data?.records || response?.data || response?.items || [];
                return {
                    data: records,
                    total: response?.data?.totalCount || response?.count || 0,
                };
            })
            .get();
    },

    apiGetSchoolList(data = {}) {
        return this.request(this.api().getSchoolList, data)
            .exec()
            .log()
            .mapresults((res) => res)
            .get();
    },

    apiGetAllSchoolListForCoordinator(data = {}) {
        return this.request(this.api().getAllSchoolListForCoordinator, data)
            .exec()
            .log()
            .mapresults((res) => res)
            .get();
    }
}

